import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./ResetPassword.css";

const USERS_BASE_URL = import.meta.env.VITE_USERS_BASE_URL;

const ResetPassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;

  const handleChangePassword = async () => {
    if (!oldPassword || !newPassword || !confirmPassword) {
      setError("All fields are required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }

    try {
      const response = await fetch(
        `${USERS_BASE_URL}/reset-password/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
          email,
          old_password: oldPassword,
          new_password: newPassword,
          new_password_confirm: confirmPassword
          })
        }
      );

      const data = await response.json();

      if (data.message === "Password has been reset successfully.") {
        alert("Password changed successfully!");
        navigate("/login");
      } else {
        setError(data?.error || "Password reset failed.");
      }
    } catch (error) {
      setError("Server error. Please try again.");
    }
  };

  return (
    <div className="reset-container">
      <h2>Create New Password</h2>
      <p className="description">
        Enter a unique and strong password that is easy to remember so that you
        won't forget it the next time.
      </p>

      <input
        type="password"
        placeholder="Current Password"
        value={oldPassword}
        onChange={(e) => setOldPassword(e.target.value)}
      />

      <input
        type="password"
        placeholder="New Password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />

      <input
        type="password"
        placeholder="Confirm New Password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />

      {error && <p className="error">{error}</p>}

      <button className="reset-button" onClick={handleChangePassword}>
        Change Password
      </button>
    </div>
  );
};

export default ResetPassword;
